module.exports = __webpack_public_path__ + "img/symbol_3.b5a5f392.png";